import { SolutionTypeFlags } from '../../../../shared/constants/user-info/solutionType';
import { getDefaultFormTimezone } from '../../../../shared/utils/timezoneUtils/getDefaultFormTimezone';
import { CHALLENGE_CUSTOMER_TYPE } from '../../../constants/challengeCustomerType';
import { ChallengeFormValues } from '../../../interfaces/ChallengeFormValues';

export const getChallengeCreateDefaultValues = (
  availableSolutionsFlags: SolutionTypeFlags,
): ChallengeFormValues => {
  // only one option is available when nutrition solution is not available
  const customerType = availableSolutionsFlags.NUTRITION
    ? ''
    : CHALLENGE_CUSTOMER_TYPE.OPEN_TO_EVERYONE;

  return {
    about: {
      challengeName: '',
      scoringRules: '',
      customerType,
      price: '',
      description: '',
      divisions: [],
      about: '',
      additionalInfo: '',
    },
    banners: {
      webBanner: null,
      mobileBanner: null,
    },
    importantDates: {
      timeZone: getDefaultFormTimezone(null),
      startDate: null,
      endDate: null,
      registrationStartDate: null,
      registrationEndDate: null,
      firstScanStartDate: null,
      firstScanEndDate: null,
      lastScanStartDate: null,
      lastScanEndDate: null,
    },
    faqs: {
      enabled: false,
      faqs: [],
    },
    prizes: {
      enabled: false,
      prizes: [],
    },
  };
};
